var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9956 3.62313e-06C8.07935 3.62313e-06 5.28261 1.15889 3.22055 3.22179C1.15848 5.28469 0 8.08262 0 11C0.0279928 12.9286 0.538289 14.8194 1.48437 16.5C1.56925 16.6492 1.62019 16.8152 1.63349 16.9864C1.6468 17.1575 1.62215 17.3295 1.56135 17.49L0.824666 19.954C0.768443 20.1261 0.78183 20.3135 0.86198 20.476C0.94213 20.6384 1.08269 20.7629 1.25351 20.823C1.40529 20.8836 1.57453 20.8836 1.72631 20.823L3.92542 20.163C4.21047 20.0969 4.50701 20.0983 4.79143 20.1671C5.07585 20.2358 5.34029 20.37 5.56375 20.559C7.0273 21.3927 8.66276 21.8789 10.3439 21.9801C12.025 22.0814 13.7069 21.7948 15.2599 21.1428C16.8128 20.4907 18.1953 19.4905 19.3006 18.2193C20.4059 16.9481 21.2046 15.4398 21.6349 13.8109C22.0653 12.182 22.1159 10.4759 21.7828 8.82431C21.4497 7.17273 20.7418 5.61979 19.7137 4.28526C18.6857 2.95073 17.3649 1.87025 15.8533 1.12726C14.3417 0.384269 12.6797 -0.00136366 10.9956 3.62313e-06Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6347 11.0109C14.6347 10.7324 14.7172 10.4602 14.8719 10.2286C15.0265 9.9971 15.2463 9.81663 15.5035 9.71006C15.7607 9.6035 16.0437 9.57564 16.3167 9.62997C16.5897 9.6843 16.8405 9.81836 17.0373 10.0153C17.2342 10.2122 17.3682 10.4631 17.4225 10.7362C17.4768 11.0093 17.449 11.2925 17.3424 11.5497C17.2359 11.807 17.0555 12.0269 16.8241 12.1816C16.5926 12.3363 16.3205 12.4189 16.0422 12.4189C15.8578 12.4204 15.675 12.3853 15.5043 12.3157C15.3336 12.2462 15.1784 12.1435 15.0476 12.0137C14.9167 11.8838 14.8129 11.7293 14.742 11.5591C14.6711 11.3888 14.6347 11.2063 14.6347 11.0219V11.0109ZM9.56576 11.0109C9.56793 10.7329 9.65233 10.4618 9.8083 10.2317C9.96426 10.0016 10.1848 9.8228 10.4422 9.71792C10.6995 9.61304 10.9821 9.58676 11.2544 9.64232C11.5267 9.69788 11.7764 9.83284 11.9722 10.0302C12.1679 10.2275 12.3009 10.4784 12.3543 10.7512C12.4077 11.0241 12.3792 11.3066 12.2724 11.5632C12.1655 11.8199 11.9851 12.0392 11.7539 12.1934C11.5227 12.3476 11.251 12.4299 10.9732 12.4299C10.787 12.4314 10.6024 12.3956 10.4303 12.3247C10.2581 12.2538 10.1018 12.1492 9.97071 12.0169C9.83958 11.8847 9.73625 11.7276 9.66669 11.5548C9.59714 11.3821 9.56282 11.1971 9.56576 11.0109ZM4.49683 11.0109C4.49683 10.7324 4.57935 10.4602 4.734 10.2286C4.88865 9.9971 5.10848 9.81663 5.36565 9.71006C5.62283 9.6035 5.90576 9.57564 6.17877 9.62997C6.45179 9.6843 6.70259 9.81836 6.89942 10.0153C7.09625 10.2122 7.23033 10.4631 7.28464 10.7362C7.33894 11.0093 7.31103 11.2925 7.20451 11.5497C7.09798 11.807 6.91759 12.0269 6.68614 12.1816C6.45469 12.3363 6.18259 12.4189 5.90422 12.4189C5.53095 12.4189 5.17297 12.2706 4.90903 12.0065C4.64508 11.7425 4.49683 11.3843 4.49683 11.0109Z",
    fill: "#F4FAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 22,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.65517,
    y1: -22.44,
    x2: 26.852,
    y2: -20.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubChat);
export default __webpack_public_path__ + "static/media/sub_chat.a490c65d79fc5769f0c0da0f805eb01e.svg";
export { ForwardRef as ReactComponent };